import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Warehouse } from './warehouse';

 import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class WarehouseService {
	baseUrl = environment.baseUrl;
  private WarehouseUrl = this.baseUrl + '/api/warehouse';  // URL to web api
  private warehouseByidUrl = this.baseUrl + '/api/warehouse/GetWarehouseDetails' //for details page by id
 
   
  constructor( 
    private http: HttpClient
  ) { }
 
  // getEntity (): Observable<Warehouse[]> {
	// return this.http.get<Warehouse[]>(this.WarehouseUrl)
  // }
  getWarehouse (): Observable<Warehouse[]> {
    return this.http.get<Warehouse[]>(this.WarehouseUrl)
    }

   GetWarehouseDetails(warehouseid: number): Observable<Warehouse> {
    const url = `${this.warehouseByidUrl}/${warehouseid}`;
    return this.http.get<Warehouse>(url);
  }

  GetWarehouses(warehouseid: number): Observable<Warehouse> {
    const url = `${this.WarehouseUrl}/${warehouseid}`;
    return this.http.get<Warehouse>(url);
  }
   
 
  addWarehouse (warehouse: Warehouse): Observable<Warehouse> {
    return this.http.post<Warehouse>(this.WarehouseUrl, warehouse, httpOptions);
  }
     
  deleteWarehouse (warehouse: Warehouse | number): Observable<Warehouse> {
    const warehouseid = typeof warehouse === 'number' ? warehouse : warehouse.warehouseid;
    const url = `${this.WarehouseUrl}/${warehouseid}`;
 
    return this.http.delete<Warehouse>(url, httpOptions);
  }
 
  updateWarehouse (warehouse: Warehouse): Observable<any> {
    return this.http.put(this.WarehouseUrl, warehouse, httpOptions);
  }

}